<template>
  <div>
    <app-header is-left left-text="地址管理" @click-left="goBack"></app-header>
    <div class="app-body" ref="body">
      <van-address-list
        v-model="chosenAddressId"
        :list="list"
        @add="onAdd"
        @edit="onEdit"
        @select="onSelect"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from 'jystore/mutation-types';
import AppHeader from '../app-header';
import tools from '@/utils/tools';
export default {
  mixins: [tools],
  components: {
    AppHeader
  },
  props: {
    back: String
  },
  data () {
    return {
      isLoading: false,
      chosenAddressId: '',
      list: [],
    }
  },
  computed: {
    ...mapGetters({
      reloadAddress: [types.OTHER.reloadAddress]
    }),
  },
  watch: {
    reloadAddress() {
      this.loadData();
    }
  },
  created () {
  },
  mounted () {
  },
  activated() {
    // if (!this.list || !this.list.length) {
      this.loadData();
    // }
  },
  methods: {
    loadData() {
      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.doGet({
        url: 'vue/personal/address',
        okcb: (json) => {
          this.list = json;
          let ids = this.list.filter(d => d.default);
          if (ids.length) {
            this.chosenAddressId = ids[0].id;
          }
        },
        cb: () => {
          this.Toast.clear();
        }
      })
    },
    goBack() {
      this.$router.push(this.back || '/user');
    },
    onAdd() {
      this.$router.push('/user/address-edit');
    },
    onEdit(item) {
      let _item = Object.assign({}, item, {addressDetail: item.address, areaCode: item.areacode});
      this.$router.push({name:'user-address-edit', params: {obj: _item}});
    },
    onSelect(item) {
      this.Toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      this.doPost({
        url: 'vue/personal/address/set/'+ item.id,
        okcb: () => {
          this.$store.commit(types.MEMBER_ADDRESS, item);
          if (this.back) {
            this.$router.push(this.back);
          }
          this.Toast.clear();
        },
        cb: () => {
          this.Toast.clear();
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '//at.alicdn.com/t/font_919761_cgylur06gh.css';
.app-body {
  margin-top:46px;
  padding-bottom:5rem;
}
</style>